import { render, staticRenderFns } from "./modalAddQuizQuestion.vue?vue&type=template&id=1b8bc819&"
import script from "./modalAddQuizQuestion.vue?vue&type=script&lang=js&"
export * from "./modalAddQuizQuestion.vue?vue&type=script&lang=js&"
import style0 from "./modalAddQuizQuestion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports